var app = angular.module("leonardo");

var FieldGroupList = function($scope, $timeout, $q, $attrs, ngDialog, FieldGroupService) {

  $scope.refresh = function() {
    if (FieldGroupService.getCollection().length > 0) {
      $scope.groups = angular.copy(FieldGroupService.getCollection());
    }
    else {
      FieldGroupService.getAll({summary: true}).then(function(data) {
        $scope.groups = data;
      });
    }
  };

  $scope.editGroup = function(group) {
    FieldGroupService.get(group.id).then(function (data) {
      ngDialog.open({
        controller: 'GroupEditDialog',
        templateUrl: 'views/templates/dialog/admin/fields/group.html',
        data: {
          group: data
        }
      });
    });
  };

  $scope.showDeleteGroup = function (group) {
    FieldGroupService.get(group.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: data,
          type: 'group'
        }
      }).then(function(res){
        FieldGroupService.updateCollection(res, true);
        $scope.refresh();
      });
    });
  };

  $scope.$on('group:changed', function($event, key, value) {
    $scope.refresh();
  });

  $timeout(function () {
    $scope.refresh();
  }, 0);

};

app.controller('FieldGroupList', ['$scope', '$timeout', '$q', '$attrs', 'ngDialog', 'FieldGroupService', FieldGroupList]);
